import { render, staticRenderFns } from "./CommentaryListComponent.vue?vue&type=template&id=6ed28170&"
import script from "./CommentaryListComponent.vue?vue&type=script&lang=js&"
export * from "./CommentaryListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports